import intl from "src/internationalization/intl"
import { Grid, InnerSection, LinearProgress, Section, TopClientCard } from "src/lib"
import { FinanceMode } from "src/lib/icons/FinancialMode"
import { useClientsOverviewSection } from "./useClientsOverviewSection"

const ClientsOverviewSection = () => {
    const { data, loading, handleClickAIButton } = useClientsOverviewSection()
    

    return (
        <Section
            title={intl("clientsOverview")}
            icon={<FinanceMode />}
            flex
            onClickAIButton={handleClickAIButton}
        >
            {loading && (
                    <Grid sx={{width: "100%"}}>
                        <LinearProgress />
                    </Grid>
                )}
            {!loading && (<>
                <InnerSection
                    title={intl('volumeUnderCustody')}
                    text={data?.totalAmountFormatted ?? "—"}
                />
                <InnerSection
                    title={intl('clientsTotal')}
                    text={data?.numberOfClients?.toString() ?? "—"}
                />
                <InnerSection title={intl('top3Clients')}>
                    
                        <Grid container gap={1}>
                            {data?.topClients.map((client) => (
                                <TopClientCard
                                    key={client.clientName}
                                    clientName={client.clientName}
                                    clientInvestProfile={client.clientInvestProfile}
                                    clientAmount={client.clientAmount}
                                    context={client.clientName} // comentario: idealmente seria um id unico, mas nao existe isso ainda
                                />
                            ))}
                        </Grid>
                    
                </InnerSection>
            </>)}
        </Section>
    )
}

export { ClientsOverviewSection }

